import { upperFirst } from "lodash";

import { SELECTED_ENGAGMENT_METRIC_QUERY_PARAM } from "single-spa/react-app/config/solutions25/competitionConst";

import { BenchmarkMetricName } from "../../../types/api.types";
import type { WebsiteLinkMetricName } from "../../../types/common";

export const METRIC_PARAMS = {
    trafficShare: {
        state: "digitalsuite_website_websiteperformance",
        additionalParams: { ignoreFilterConsistency: true },
    },
    audienceReach: {
        state: "digitalsuite_website_audienceOverlap",
        additionalParams: { ignoreFilterConsistency: true },
    },
    visits: { state: "digitalsuite_website_websiteperformance", additionalParams: { ignoreFilterConsistency: true } },
    visitDuration: {
        state: "digitalsuite_website_trafficandengagement",
        additionalParams: { ignoreFilterConsistency: true },
    },
    bounceRate: {
        state: "digitalsuite_website_trafficandengagement",
        additionalParams: {
            [SELECTED_ENGAGMENT_METRIC_QUERY_PARAM]: upperFirst(BenchmarkMetricName.bounceRate),
            ignoreFilterConsistency: true,
        },
    },
    pagesPerVisit: {
        state: "digitalsuite_website_trafficandengagement",
        additionalParams: {
            [SELECTED_ENGAGMENT_METRIC_QUERY_PARAM]: upperFirst(BenchmarkMetricName.pagesPerVisit),
            ignoreFilterConsistency: true,
        },
    },
    pageViews: {
        state: "digitalsuite_website_trafficandengagement",
        additionalParams: {
            [SELECTED_ENGAGMENT_METRIC_QUERY_PARAM]: upperFirst(BenchmarkMetricName.pageViews),
            ignoreFilterConsistency: true,
        },
    },
    marketingChannels: {
        state: "digitalsuite_website_marketingchannels_beta",
        additionalParams: {},
    },
} satisfies Record<WebsiteLinkMetricName, { state: string; additionalParams: object }>;
